import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation } from "../utils/helper";
import { compileString } from "sass";

const ActivityCard = ({ index, data, nodeType, ...props }) => {
  let day, month;

  if (data.start_date && data.start_date !== "") {
    [day, month] = data.start_date.split(" ");
    month = month ? month.slice(0, 3).toUpperCase() : "";
  }

  let doodle = "";

  if (nodeType === 'activity') {
    doodle = _getBaseUrl("themes/custom/tema/src/assets/doodles/scrib-2.svg");
  }
  else {
    doodle = _getBaseUrl("themes/custom/tema/src/assets/doodles/diamond-2.svg");
  }


  // console.log("node type", nodeType);

  return (
    <li>
      <article>
        <a href={data.permalink} className="relative library-card hover:no-underline h-full w-full md:flex gap-8">
          {index === 1 ? (
            <img
              src={doodle}
              className="w-14 absolute -top-4 -left-4 z-10"
              alt=""
            />
          ) : null}
          <div className="w-full md:w-2/5 relative">
            <div className="image pb-4 md:pb-0 aspect-video">
              {data.imageUrl ? (
                <img
                  src={data.imageUrl}
                  alt={data.imageAlt}
                  // alt=""
                  className="w-full h-full object-cover filter grayscale hover:grayscale-0"
                />
              ) : null}
            </div>
          </div>
          <div className="w-full md:w-3/5">
            <div className="flex gap-4 items-center">
              <div className="order-last">
                <h3 className="h4 !mb-0 font-normal">
                  {data.title}
                </h3>
                <div>
                  <time dateTime={data.time}>{data.time} uur</time>
                  {data.location && <> – {data.location}</>}
                </div>
              </div>
              {data.start_date && data.start_date !== "" && (
                <span className="order-first text-center px-4 font-magicb text-black flex flex-col items-center justify-center">
                  <span className="h3 !mb-0">
                    {day}
                  </span>
                  <span className="h4 !mb-0">
                    {month}
                  </span>
                </span>
              )}
            </div>
            {isArray(data.onderwerpen) &&
              data.onderwerpen.length > 0 &&
              isArray(data.gebieden) &&
              data.gebieden.length > 0 && (
                <ul className="flex flex-wrap items-center font-magicb gap-2 my-4">
                  {data.onderwerpen.length > 0 &&
                    data.onderwerpen.map((onderwerp, index) => (
                      <li key={index} className="font-magicb font-normal text-sm md:marker:text-15 uppercase bg-gewGrey px-3 py-1">
                        {onderwerp}
                      </li>
                    ))}
                  {data.gebieden.length > 0 &&
                    data.gebieden.map((gebieden, index) => (
                      <li key={index} className="font-magicb font-normal text-sm md:marker:text-15 uppercase bg-gewGrey px-3 py-1">
                        {gebieden}
                      </li>
                    ))}
                </ul>
              )}
            <div className="py-4">
              {data.text}
            </div>
            <div className="btn w-full md:w-fit">
              <span className="button-gew inline-block text-center btn-small text-sm md:text-base uppercase">Lees verder</span>
            </div>
          </div>
        </a>
      </article>
    </li>
  );
};

export default ActivityCard;
